import {
  createUseStyles,
} from 'react-jss'

const useStyles = createUseStyles((theme) => ({
  container: {
    position: 'relative',
    paddingBottom: 'var(--ui-spacer-s)',
    paddingTop: 'var(--ui-spacer-s)',
  },
  main: {
    display: 'grid',
    gridTemplateAreas: `
      "thumbnail content"
      "thumbnail price"
    `,
    gridTemplateColumns: '6.4rem 1fr',
    columnGap: 'var(--ui-spacer-m)',
    rowGap: 'var(--ui-spacer-xs)',
  },
  mainRemovable: {
    gridTemplateColumns: '6.4rem 1fr min-content',
    gridTemplateAreas: `
      "thumbnail content remove"
      "thumbnail price price"
    `,
  },
  removeButton: {
    gridArea: 'remove',
    background: 'transparent',
    border: 0,
    padding: 0,
    width: '2rem',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
    '&:focus': {
      outline: 'none',
    },
  },
  removeButtonIcon: {
    display: 'block',
    margin: 0,
    '&:focus': {
      outline: 'none',
    },
  },
  boxProductStyle: {
    display: 'flex',
  },
  thumbnail: {
    gridArea: 'thumbnail',
  },
  thumbnailImage: {},
  content: {
    gridArea: 'content',
    textAlign: 'left',
    '& :last-child': {
      marginBottom: 0,
    },
  },
  text: {
    margin: 0,
    color: 'currentColor',
    fontSize: '1.4rem',
    lineHeight: 1.42,
  },
  title: {
    fontSize: '1.6rem',
    fontWeight: 'bold',
    marginBottom: 'var(--ui-spacer-xs)',
  },
  variant: {
    marginBottom: 'var(--ui-spacer-xs)',
    '&:empty': {
      display: 'none',
    },
  },
  productTitleLink: {
    textDecoration: 'none',
  },
  addons: {
    marginBottom: 'var(--ui-spacer-xs)',
    opacity: 0.75,
    '& $text': {
      fontSize: '1.2rem',
    },
  },
  price: {
    gridArea: 'price',
    '& span': {
      fontSize: 'inherit',
      fontWeight: 'inherit',
      lineHeight: 'inherit',
    },
  },
  linePrice: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  amount: {
    fontWeight: 'bold',
    flexShrink: 0,
  },
  discountPrice: {
    fontSize: '1.2rem',
  },
  discountPriceText: {
    fontSize: 'inherit',
    opacity: 0.75,
  },
  discountPriceAmount: {
    fontSize: 'inherit',
    color: theme.colors.alert,
  },
  itemError: {
    color: theme.colors.alert,
    fontSize: '1.2rem',
    lineHeight: 1.25,
    marginTop: '1rem',
  },
}))

export default useStyles
